// @file The personal subscription products sold through the App Store. This module has no imports
// so browser bundles can load it through the package's `./store-products` entry without zod.
export const STORE_PRODUCT_IDENTIFIERS = [
  'com.wallwisher.Padlet.Gold.Monthly',
  'com.wallwisher.Padlet.Gold.Annual',
  'com.wallwisher.Padlet.Platinum.Monthly',
  'com.wallwisher.Padlet.Platinum.Annual',
] as const

export type StoreProductIdentifier = (typeof STORE_PRODUCT_IDENTIFIERS)[number]
